import React from 'react'
import Layout from '../../Components/Layout';

const ResumeParser = () => {
    return (
        <Layout>
            <div className="backgound-main-content p-4">
                <iframe
                    src="http://localhost:5000"
                    title="Resume Parser"
                    width="100%"
                    height="1000px"
                    style={{
                        border: "none",
                        overflow: "hidden"
                    }}
                />
            </div>
        </Layout>
    );
}

export default ResumeParser